(() => {
  const placeQuantityBeforeAdd = (scope = document) => {
    scope.querySelectorAll('.product__info-container').forEach((info) => {
      const quantity = info.querySelector('.product-form__quantity');
      const form = info.querySelector('product-form form[data-type="add-to-cart-form"]');
      const buttons = form?.querySelector('.product-form__buttons');

      if (!quantity || !form || !buttons) return;
      if (quantity.parentElement === form && quantity.nextElementSibling === buttons) return;

      buttons.before(quantity);
      info.dataset.paPurchaseOrder = 'options-quantity-add';
    });
  };

  const schedulePlacement = (scope = document) => {
    placeQuantityBeforeAdd(scope);
    requestAnimationFrame(() => placeQuantityBeforeAdd(scope));
    window.setTimeout(() => placeQuantityBeforeAdd(scope), 500);
    window.setTimeout(() => placeQuantityBeforeAdd(scope), 1500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => schedulePlacement(), { once: true });
  } else {
    schedulePlacement();
  }

  document.addEventListener('shopify:section:load', (event) => schedulePlacement(event.target));
})();
